export const CUSTOMER_AGENT_ACTION_EXECUTION_MESSAGE = 'CUSTOMER_AGENT_ACTION_EXECUTION_MESSAGE';